<div class="ui-g-12 leader-title" translate>TOURNAMENTS.LEADERBOARD</div>

<div *ngIf="!ds.mobile || !displayLeaderInfo" class="ui-g-12 ui-lg-6">
    <p-table *ngIf="!ds.mobile" [value]="ds.currentTournament.leaders" class="ui-g-12" [responsive]="false" [scrollable]="true" scrollHeight="calc(100vh - 20.1em)" scrollWidth="100%">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 2em;"></th>
                <th *ngIf="ds.currentTournament.isTeamEvent" translate>TOURNAMENTS.TEAMNAME</th>
                <th *ngIf="!ds.currentTournament.isTeamEvent" translate>TOURNAMENTS.PLAYERNAME</th>
                <th style="width: 5em;" translate>TOURNAMENTS.SCORE</th>
                <th style="width: 7em;" translate>TOURNAMENTS.OPPSCORE</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-l let-i="rowIndex">
            <tr (click)="onSelectLeader(l)">
                <td style="width: 2em;">{{ i + 1 }}</td>
                <td>{{ l.name }}</td>
                <td style="width: 5em; text-align: right;">{{ l.score | number: '1.1-2' }}</td>
                <td style="width: 7em; text-align: right;">{{ l.opponentScore | number: '1.1-2' }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="2" style="border: 1px solid; border-color: #d9d9d9; padding: 5px">
                    {{ 'COMMON.NORECORDSFOUND' | translate }}
                </td>
            </tr>
        </ng-template>
    </p-table>

    <p-table *ngIf="ds.mobile" [value]="ds.currentTournament.leaders" class="ui-g-12">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 1.5em;"></th>
                <th *ngIf="ds.currentTournament.isTeamEvent" translate>TOURNAMENTS.TEAMNAME</th>
                <th *ngIf="!ds.currentTournament.isTeamEvent" translate>TOURNAMENTS.PLAYERNAME</th>
                <th style="width: 4em;" translate>TOURNAMENTS.SCORE</th>
                <th style="width: 5em;" translate>TOURNAMENTS.OPPSCORE</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-l let-i="rowIndex">
            <tr (click)="onSelectLeader(l)">
                <td style="width: 1.5em;">{{ i + 1 }}</td>
                <td>{{ l.name }}</td>
                <td style="width: 4em; text-align: right;">{{ l.score | number: '1.1-2'}}</td>
                <td style="width: 5em; text-align: right;">{{ l.opponentScore | number: '1.1-2' }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="2" style="border: 1px solid; border-color: #d9d9d9; padding: 5px">
                    {{ 'COMMON.NORECORDSFOUND' | translate }}
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<div *ngIf="selectedLeader.id && (displayLeaderInfo || !ds.mobile)" class="ui-g-12 ui-lg-6 leader-summary-contrainer">
    <div *ngIf="ds.mobile" class="ui-g-12" style="text-align: right;">
        <i class="pi pi-times" style="font-size: 1.2em; color: var(--text-color-secondary)" (click)="closeLeaderSummary()"></i>
    </div>
    <div class="ui-g-12 leader-summary-header">{{ selectedLeader.name }}</div>
    <div class="ui-g-12 leader-summary-header" translate>TOURNAMENTS.TOURNAMENTSUMMARY</div>
    <div *ngFor="let bracket of bracketSummaries" class="ui-g-12">
        <div class="ui-g-12 leader-bracket-title">{{ bracket.bracketName }}</div>
        <div *ngFor="let round of bracket.roundSummaries" class="ui-g-12">
            <div *ngIf="round.complete && !round.bye" class="ui-g-12 leader-round leader-{{ round.className }}">
                {{ round.roundString }}:&nbsp;
                <span *ngIf="round.wins >= round.losses">{{ round.wins }}&nbsp;-&nbsp;{{ round.losses }}</span>
                <span *ngIf="round.losses > round.wins">{{ round.losses }}&nbsp;-&nbsp;{{ round.wins }}</span>&nbsp;
                {{ round.summaryString }} &nbsp;
                <span translate>TOURNAMENTS.VERSUS</span>&nbsp;
                {{ round.opponentName }}
            </div>
            <div *ngIf="!round.complete" class="ui-g-12 leader-round leader-in-progress">
                {{ round.roundString }}:&nbsp;
                <span translate>TOURNAMENTS.INPROGRESS</span>&nbsp;
                <span translate>TOURNAMENTS.VERSUS</span>&nbsp;
                {{ round.opponentName }}&nbsp;
                <span translate>TOURNAMENTS.ONPITCH</span>&nbsp;
                {{ ds.getFieldName(round.fieldName) }}&nbsp;
                {{ round.pitchNum }}
            </div>
            <div *ngIf="round.bye" class="ui-g-12 leader-round leader-win">
                {{ round.roundString }}:&nbsp;
                <span translate>TOURNAMENTS.BYE</span>
            </div>
        </div>
    </div>
    <div class="ui-g-12 leader-bracket-title" translate>TOURNAMENTS.TOTALS</div>
    <div class="ui-g-12 leader-round leader-totals">
        <span translate>TOURNAMENTS.TOTALGAMES</span>:&nbsp;
        {{ totalSummary.wins + totalSummary.losses + totalSummary.ties }}
    </div>
    <div class="ui-g-12 leader-round leader-totals" style="padding-top: .5em;">
        <span translate>TOURNAMENTS.OVERALLRECORD</span>:&nbsp;
        {{ totalSummary.wins }}&nbsp;-&nbsp;{{ totalSummary.losses }}&nbsp;-&nbsp;{{ totalSummary.ties }}
    </div>
</div>